import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card, Container } from 'react-bootstrap';

import { getContentBlockItemValue } from '../../../Cms/CmsActions.js';

import Icon from '../../../../components/Content/Icon.js';
import PageWrapper from '../../../../components/Content/PageWrapper.js';
import PageTitle from '../../../../components/Content/PageTitle.js';
import HtmlComponent from '../../../../components/Text/HtmlComponent.js';
import InfluencerForm from '../../components/form/InfluencerForm.js';

function PageInfluencer({ page }) {
    const intro = getContentBlockItemValue(page.blocks, 'intro');
    const success = getContentBlockItemValue(page.blocks, 'success');

    return (
        <Container className="page-wrapper bg-company">
            <PageWrapper>
                <PageTitle>
                    <h1>
                        <Icon icon="user-add" /> {page.title || <FormattedMessage id="influenceurFormTitle" defaultMessage="Become a partner influencer" />}
                    </h1>
                </PageTitle>
                <InfluencerForm introContent={intro} successContent={success || null} />
            </PageWrapper>
        </Container>
    );
}

PageInfluencer.propTypes = {
    page: PropTypes.object.isRequired,
};

export default PageInfluencer;
